/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment'
import { Button, Form } from 'antd'
import { useWindowSize } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import { getFilteredInvoicesAPI } from 'src/features'
import styles from './DownloadInvocesPageContent.module.scss'
import { CustomDateRangeInput, CustomText } from 'src/components'
import { showToast, exportPdfZip, getInvoiceFilePayload } from 'src/core/helpers'

const DownloadInvocesPageContent: React.FC = () => {
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const [isLoading, setIsLoading] = useState(false)
  const [isErrorVisible, setIsErrorVisible] = useState(false)

  const handleFinish = async (values: { date_start: moment.Moment, date_end: moment.Moment }) => {
    setIsLoading(true)
    setIsErrorVisible(false)
    const payload = {
      date_start: moment(values.date_start).format('YYYY-MM-DD'),
      date_end: moment(values.date_end).format('YYYY-MM-DD')
    }
    const invoicesUrls = await getFilteredInvoicesAPI(payload)
    if (invoicesUrls.length === 0) { setIsErrorVisible(true) }
    else {
      const fileName = `Invoices_${payload.date_start}_${payload.date_end}`
      const pdfUrls = getInvoiceFilePayload(invoicesUrls)
      await exportPdfZip(fileName, pdfUrls)
      setFormDataFields()
      showToast('success', t('Invoices.Success'))
    }
    setIsLoading(false)
  }

  useEffect(() => {
    setFormDataFields()
    return (() => { setIsErrorVisible(false) })
  }, [form])

  const setFormDataFields = () => {
    form.setFieldsValue({
      date_start: moment().subtract(31, 'days'),
      date_end: moment()
    })
  }

  return <Form onFinish={handleFinish} form={form}>
    {/* Form Content */}
    <CustomDateRangeInput rigthCol={12} />

    <div className={styles.buttonsContent}>
      {/* Error Validations */}
      {isErrorVisible ? <div className='blink-animation'>
        <CustomText
          type='danger'
          label={t('Invoices.Error')}
          className={isMobile && 'mb-4'}
        />
      </div> : <div />}

      {/* Submit Button */}
      <Button
        size='large'
        type='primary'
        htmlType='submit'
        block={isMobile}
        loading={isLoading}
        icon={<DownloadOutlined />}
        className={`radius-100`}
      >
        {isLoading ? t('general.Downloading') : t('Invoices.Download')}
      </Button>
    </div>
  </Form>
}

export default DownloadInvocesPageContent
